const TaskScreen = () => {
  return <div>{"Task screen"}</div>;
};

export default TaskScreen;
